/**
 * useCountries - Hook para obtener la lista de países disponibles
 * 
 * Carga todos los países desde GET /countries con su información completa
 * (id, name, iso2, iso3, phoneCode). Los datos se cachean durante 30 minutos
 * ya que raramente cambian. Usado en filtros avanzados para el filtro de país.
 * 
 * @returns {Object} { countries: lista de países, isLoading, error, refetch }
 */

import { useQuery } from '@tanstack/react-query';
import { CountriesApiAdapter } from '../adapters/CountriesApiAdapter';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

export const useCountries = () => {
  const countriesAdapter = new CountriesApiAdapter(createHttpClient(apiClientWH));

  const {
    data: countries = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['countries'],
    queryFn: () => countriesAdapter.getAll(),
    staleTime: 30 * 60 * 1000, // 30 minutos - los países cambian raramente
    gcTime: 60 * 60 * 1000, // 1 hora
  });

  return {
    countries,
    isLoading,
    error: error?.message || null,
    refetch,
  };
};

